<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.billing">
  <app-popup-header title="{{localService.languageContent.billing.status_history}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="items">
    <div class="row styled_row" *ngFor="let item of items">
      <div class="col-md-8">
        <div class="row">
          <div class="col-6">
            <span class="en">{{item.v5 | localDate}}</span>
          </div>
          <div class="col-6">
            <span>{{localService.getText(localService.billingStatus,item.v1)}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <span class="button"  [ngClass]="localService.getLanguageCode(item.v3)" (click)="localService.showSummary(item.v2,1)">{{item.v4}}</span>
      </div>
    </div>
  </div>
</div>
